import { render, staticRenderFns } from "./BeaconList.vue?vue&type=template&id=616a6386&"
import script from "./BeaconList.vue?vue&type=script&lang=js&"
export * from "./BeaconList.vue?vue&type=script&lang=js&"
import style0 from "./BeaconList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports